import { SummaryModel } from "src/app/modules/common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";
import {UserSummary} from "../../../../../account/modules/user/api/entity/userSummary.model";

export class PrescriptionDefinitionSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    label: string;
    owner: UserSummary;
}